/* eslint-disable no-unused-vars */
import axios from "../../axios";

const state = {
  lessons: [],
  totalRecords: 0,
  totalPages: 1,
  currentPage: 1,
  perPage: 10,
  isResetPage: false,
};

const actions = {
  /**
   * Get List lessons
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getCustomizeLessons({ commit }, { customize_course, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `customized-courses/${customize_course}/customized-lessons?${new URLSearchParams(
            query,
          )}`,
        )
        .then((response) => {
          commit("SET_LESSONS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Create Lesson
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async createCustomizeLesson({ commit }, { customize_course, payload }) {
    return await axios.post(
      `customized-courses/${customize_course}/customized-lessons`,
      payload,
    );
  },

  /**
   * Delete Lesson
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async deleteCustomizeLesson(
    { commit },
    { customize_course, customize_lesson },
  ) {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `customized-courses/${customize_course}/customized-lessons/${customize_lesson}`,
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Delete Lesson
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async changeCustomizeLessonOrder({ commit }, { customize_course, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `customized-courses/${customize_course}/customized-lessons/order`,
          payload,
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setCurrentPage({ commit }, currentPage) {
    commit("SET_CURRENT_PAGE", currentPage);
  },

  setTotalPages({ commit }, total) {
    commit("SET_TOTAL_PAGES", total);
  },

  updateLessons({ commit }, data) {
    commit("SET_LESSONS", data);
  },

  updateLessonSections({ commit }, sections) {
    commit("SET_LESSON_SECTIONS", sections);
  },

  updateLessonSection({ commit }, section) {
    commit("SET_LESSON_SECTION", section);
  },

  /**
   * Set reset page
   * @param {*} param0
   * @param {*} status
   */
  setStatusResetPage({ commit }, status) {
    commit("SET_RESET_PAGE", status);
  },
};

const mutations = {
  SET_LESSONS(state, data) {
    state.lessons = data;
  },
  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },
  SET_TOTAL_PAGES(state, total) {
    state.totalPages = total;
  },
  SET_LESSON_SECTIONS(state, sections) {
    if (sections.length) {
      let lessons = state.lessons;
      let lessonFindIdx = lessons.findIndex((item) => {
        return item.id === sections[0].lesson_id;
      });
      if (lessonFindIdx >= 0) {
        lessons[lessonFindIdx].sections = sections;
        state.lessons = lessons;
      }
    }
  },
  SET_LESSON_SECTION(state, section) {
    let lessons = state.lessons;
    let lessonFindIdx = lessons.findIndex((item) => {
      return item.id === section.lesson_id;
    });
    if (lessonFindIdx >= 0) {
      const findIndex = lessons[lessonFindIdx].sections.findIndex((item) => {
        return item.id === section.id;
      });
      if (findIndex >= 0) {
        //update
        lessons[lessonFindIdx].sections[findIndex] = section;
      } else {
        lessons[lessonFindIdx].sections.push(section);
      }
      state.lessons = lessons;
    }
  },
  SET_RESET_PAGE(state, status) {
    state.isResetPage = status;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
